/**
 * CCU UI組件
 * 顯示遊戲分數和標籤的UI元素
 */
export default class CCU extends Phaser.Group {

  /**
   * 創建CCU UI組件
   * @param {Phaser.Game} game - Phaser遊戲實例
   * @param {string} bgasset - 背景資源名稱（未使用）
   * @param {number} val - 初始數值
   * @param {Phaser.Group} parent - 父群組
   */
  constructor(game, bgasset, val, parent) {
    super(game, parent);

    this.create(0, 0, null);

    // 創建數值文字
    const valueStyle = {
      font: "30px Arial",
      align: "center",
      fill: "#000",
      backgroundColor: '#FFF'
    };
    this.txtValue = new Phaser.Text(this.game, 55, 55, val.toString(), valueStyle);
    this.add(this.txtValue);

    // 創建標籤文字
    const labelStyle = {
      fill: '#000',
      backgroundColor: '#fff'
    };
    const label = new Phaser.Text(this.game, 155, 55, "網站 BUG 數量!!", labelStyle);
    this.add(label);
  }

  /**
   * 更新顯示的數值
   * @param {number} val - 新的數值
   */
  setValue(val) {
    this.txtValue.text = val.toString();
  }
}
